"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// 登录
var domain = process.env.VUE_APP_BASE_API_LOGIN;
var LoginService = /*#__PURE__*/function (_Service) {
  function LoginService() {
    (0, _classCallCheck2.default)(this, LoginService);
    return _callSuper(this, LoginService, arguments);
  }
  (0, _inherits2.default)(LoginService, _Service);
  return (0, _createClass2.default)(LoginService, [{
    key: "login",
    value: function login(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.post(domain + '/oauth/login', param);
    }
  }, {
    key: "getInfo",
    value: function getInfo(param) {
      param.pid = process.env.VUE_APP_PID;
      return this.http.get(domain + '/get_login_admin', param);
    }
    // 登录日志
  }, {
    key: "loginLog",
    value: function loginLog(data) {
      return this.http.post('/api/log', data);
    }
    // 日志列表
  }, {
    key: "logList",
    value: function logList(param) {
      return this.http.get('/api/log', {
        params: param
      });
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new LoginService();